<style>
/* Display as block element */
:host {
    display: block;
}

:host([hidden]) {
    display: none;
}

/* Mobile version: vertical */
.button-bar {
    border: 1px solid var(--primary-bg);
    border-radius: 0.1em;

    list-style: none;
    margin: 0 0 1em 0;
    padding: 0;

    background: var(--secondary-bg);
    color: var(--secondary-fg);

    overflow: hidden;
}

.tab-button,
.dropdown {
    padding: 0.5em;
    cursor: pointer;
    transition: var(--transition-background), var(--transition-color);
}

.tab-button[active],
.tab-button:hover {
    background-color: var(--primary-bg);
    color: var(--primary-fg);
}

.page:not([active]) {
    display: none;
}

/* Screen version: horizontal */
.container.horizontal .button-bar-outer {
    display: inline-block;
}

.container.horizontal .button-bar {
    display: flex;
    flex-wrap: wrap;
}

/* Dropdown menu for vertical mode */
.container.horizontal .dropdown {
    display: none;
}

.dropdown {
    display: flex;

    border: 1px solid var(--primary-bg);
    border-radius: 0.1em;

    background: var(--primary-bg);
    color: var(--primary-fg);
}

.dropdown .active-tab-title {
    flex: 1;
}

.container.vertical .closed {
    height: 0;
    border-width: 0px;
}
</style>
